export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      const serviceType = 'BUSINESS';
      function toggleClasses(selected, nonSelected) {
        selected.classList.replace('tertiary', 'primary');
        nonSelected.classList.replace('primary', 'tertiary');
      }
      function getServiceInfo(type) {
        const container = document.querySelector('.business-button');
        const secondaryButton = document.querySelector('.personal-button');
        return {
          BUSINESS: {
            serviceType: 'BUSINESS',
            buttonLabel: 'GET BUSINESS VIRTUAL ADDRESS',
            serviceUrl: 'https://orders.bizee.com/virtual-address',
            containers: [container, secondaryButton],
          },
          PERSONAL: {
            serviceType: 'PERSONAL',
            buttonLabel: 'GET PERSONAL VIRTUAL ADDRESS',
            serviceUrl: 'https://orders.bizee.com/personal-virtual-address',
            containers: [secondaryButton, container],
          },
        }[type];
      }
      function toggleService(type) {
        const serviceInfo = getServiceInfo(type);
        Object.entries(serviceInfo).forEach(([key, value]) => {
          if (key === 'containers') {
            toggleClasses(...value);
          } else {
            this[key] = value;
          }
        });
      }

      instance.data('VirtualAddress', () => ({
        serviceType,
        buttonLabel: 'GET BUSINESS VIRTUAL ADDRESS',
        serviceUrl: 'https://orders.bizee.com/virtual-address',
        changeType: toggleService,
      }));
    });
  },
};
